// extracted by mini-css-extract-plugin
export default {"link":"link_link__+Nznz","default":"link_default__XfQnk","work":"link_work__nWbW0","about":"link_about__SH4De"};